<div *ngIf="productList.length != 0" class="cart-column-spacing stock-listing pink-bg out-of-stock">
    <h3 class="d-none d-lg-flex">Out of Stock<span class="product-count">{{totalProductCount}} Products</span></h3>
    <div class="product-grid scrollbar d-none d-lg-flex" *ngIf="!noRecord" infiniteScroll [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" [scrollWindow]="false" [horizontal]="true">
        <div class="product-wrapper" id="product_{{product.product_id}}" *ngFor="let product of productList">
            <ul class="product-type" *ngIf="product.price_marked == 1">
                <li>
                    <img src="../../assets/images/pmp.svg" class="pmp-image" alt="checked icon" />
                </li>
            </ul>
            <div class="product-inner-wrapper">
                <div class="product-image">
                    <a href="javascript:void(0)">
                        <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                    </a>
                </div>
                <div class="product-description">
                    <h2>{{product.short_desc}}</h2>
                    <button class="btn primary-btn disabled">Out of Stock</button>
                </div>
            </div>
        </div>
    </div>

    <div class="product-grid  scroll-body d-flex d-lg-none" *ngIf="!noRecord" infiniteScroll
        [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" [scrollWindow]="false">
        <div class="product-wrapper" id="product_{{product.product_id}}" *ngFor="let product of productList">
            <ul class="product-type" *ngIf="product.price_marked == 1">
                <li>
                    <img src="../../assets/images/pmp.svg" alt="checked icon" />
                </li>
            </ul>
            <div class="product-inner-wrapper">
                <div class="product-image">
                    <a href="javascript:void(0)">
                        <img src="{{imagePath}}{{product?.images[0]}}" alt="">
                    </a>
                </div>
                <div class="product-description">
                    <h2>{{product.short_desc}}</h2>
                    <button class="btn primary-btn disabled">Out of Stock</button>
                </div>
            </div>
        </div>
    </div>
</div>